import {AppComponent} from './app/app.component';
import {ApiService} from './app/services/api/api.service';
import {AuthService} from './app/services/auth/auth.service';
import {WebsocketService} from './app/services/websocket/websocket.service';
import {DialogService} from './app/services/dialog/dialog.service';
import {ConfirmDialogService} from './app/services/confirm-dialog-service/confirm-dialog.service';
import {AuthorisationService} from './app/services/auth/authorisation.service';
import {DatePipe, registerLocaleData} from '@angular/common';
import {CdkDropList} from '@angular/cdk/drag-drop';
import {LoggerService} from './app/services/logger.service';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter} from '@angular/material/core';
import {ErrorHandler, LOCALE_ID, provideAppInitializer, inject, Injectable} from '@angular/core';
import {CustomErrorHandlerService} from './app/custom-error-handler-service';
import {MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions} from '@angular/material/tooltip';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions} from '@angular/material/form-field';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {CodaltInterceptor} from './app/codalt.interceptor';
import {routes} from './app/app-routing.module';
import {provideRouter, TitleStrategy} from '@angular/router';
import {PageTitleStrategy} from './app/page-title.strategy';
import {IsAuthenticated} from './app/is-authenticated';
import {IsNotAuthenticated} from './app/is-not-authenticated';
import {bootstrapApplication} from '@angular/platform-browser';
import {firstValueFrom} from 'rxjs';
import localeNL from '@angular/common/locales/nl';
import {DD_MM_YYYY_FORMAT} from './date-formats';

registerLocaleData(localeNL, 'nl');

const formFieldDefaults: MatFormFieldDefaultOptions = {
    appearance: 'outline',
    subscriptSizing: 'dynamic'
};

export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
    showDelay: 750,
    hideDelay: 0,
    touchendHideDelay: 2000,
    disableTooltipInteractivity: true
};

@Injectable()
export class FirstDayMondayDateAdapter extends NativeDateAdapter {
    getFirstDayOfWeek(): number {
        return 1; // Stel maandag in als de eerste dag van de week
    }

    format(date: Date, displayFormat: string): string {
        if (displayFormat === 'dd-MM-yyyy') {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        }
        return super.format(date, displayFormat);
    }
}

bootstrapApplication(AppComponent, {
    providers: [
        ApiService,
        AuthService,
        IsAuthenticated,
        IsNotAuthenticated,
        WebsocketService,
        DialogService,
        ConfirmDialogService,
        AuthorisationService,
        DatePipe,
        CdkDropList,
        LoggerService,
        {provide: MAT_DATE_LOCALE, useValue: 'nl'},
        {provide: MAT_DATE_FORMATS, useValue: DD_MM_YYYY_FORMAT},
        {provide: DateAdapter, useClass: FirstDayMondayDateAdapter},
        {provide: ErrorHandler, useClass: CustomErrorHandlerService},
        {provide: LOCALE_ID, useValue: 'nl'},
        {provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myCustomTooltipDefaults},
        {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: formFieldDefaults},
        {provide: HTTP_INTERCEPTORS, useClass: CodaltInterceptor, multi: true},
        provideRouter(routes),
        {provide: TitleStrategy, useClass: PageTitleStrategy},
        provideHttpClient(withInterceptorsFromDi()),
        provideAppInitializer(() => {
            const authService = inject(AuthorisationService);
            return firstValueFrom(authService.rightsMap());
        })
    ]
})
    .catch((err) => console.error(err));
